export default "__VITE_ASSET__fLh_kwu8__"